export interface ICompilationDescription {
	// genre: ICompilationDescriptionGenre;
	[key: string]: string;
}
export interface ICompilationDescriptionGenre {
	[key: string]: string;
}

export interface IConfig {
	hosts: {
		api: string;
		baseUrl: string;
		baseUrlDesktop: string;
		auth: string;
		rb: string;
		static: string;
		restApiUrl: string;
		recommendTechInfoUrl: string;
	};

	apps: {
		pathname: string;
		isSalesEnable: boolean;
		isShowcaseEnable: boolean;
		isNewEnable: boolean;
		// таймаут на голосование за игру
		votingCooldown: number;
		// максимвальное кол-во игр в разделе "популярное"
		totalPopular: number;
		compilationDescription: ICompilationDescription;
	};

	createMyWarning: string;
	countersUpdateInterval: number;

	isTestServer: boolean;
	isServerRendering: boolean;
	isLocalServer: boolean;
	isMockData: boolean;
	isProcessingSdc: boolean;

	payment: {
		isUseIssuerid: boolean;
	};

	installPwaPanelText: {
		mobile: string;
		tablet: string;
		desktop: string;
	};
	isShowInstallBtn: boolean;
	installButtonHideDuration: number;
	isPwaEnabled: boolean;
	isTwa: boolean;
	userAgent: string;
	referrer: string;

	isMobile: boolean;
	isOpenStack: boolean;

	isAndroidApp: boolean;

	browserFamily: string;

	isError: boolean;
	isError403: boolean;
	isError404: boolean;
	isError500: boolean;
	isError502: boolean;

	holidaysConfig: {
		logoUrl?: string;
	};

	errorsMonitoring: {
		percent: number;
		ignore: string;
		enableDebug: boolean;
		sameReportTimeout: number;
	};

	timeTracker: {
		enabled: boolean;
		url: string;
		retryTimeout: number;
		maxFailedAttempts: number;
	};

	appearance: {
		theme?: string;
	};
}

export const DEFAULT_CONFIG: IConfig = {
	hosts: {
		api: '',
		baseUrl: '',
		baseUrlDesktop: '',
		auth: '',
		rb: '',
		static: '',
		restApiUrl: '',
		recommendTechInfoUrl: '',
	},

	apps: {
		pathname: '/apps',
		isSalesEnable: true,
		isShowcaseEnable: true,
		isNewEnable: true,
		votingCooldown: 0,
		totalPopular: 10,
		compilationDescription: null,
	},

	createMyWarning: '',

	countersUpdateInterval: 0,

	isTestServer: false,
	isServerRendering: false,
	isLocalServer: false,
	isMockData: false,
	isProcessingSdc: true,

	payment: {
		isUseIssuerid: false,
	},

	installPwaPanelText: {
		mobile: '',
		tablet: '',
		desktop: '',
	},
	isShowInstallBtn: false,
	installButtonHideDuration: 24 * 60 * 60 * 1000,
	isPwaEnabled: false,
	isTwa: false,
	userAgent: '',
	referrer: '',
	isMobile: false,
	isOpenStack: false,

	isAndroidApp: false,

	browserFamily: '',

	isError: false,
	isError403: false,
	isError404: false,
	isError500: false,
	isError502: false,

	holidaysConfig: {},

	errorsMonitoring: {
		percent: 0,
		ignore: '',
		enableDebug: false,
		sameReportTimeout: 1000,
	},

	timeTracker: {
		enabled: false,
		url: '',
		retryTimeout: 0,
		maxFailedAttempts: 0,
	},

	appearance: {
		theme: null,
	},
};

let CONFIG = { ...DEFAULT_CONFIG };

export const setConfig = (config: IConfig) => CONFIG = { ...DEFAULT_CONFIG, ...config };

export const getConfig = () => CONFIG;
